import { icon, Icon } from '../lib/fa-icons.js';
import Widget from "./base.js";
import { setCookie, getCookie } from "tpm-utils";

export class FundraiserBannerWidget extends Widget {
	componentWillMount() {
		window.tpm_fb = this;
		this.showTotalContributors = true;
		this.state.totalContributors = undefined;

		if (!window.is_prime) {
			this.state.dismissed = true;
			return;
		}

		const dismissed = getCookie("tpm_dismiss_fundraiser_components");
		if (dismissed) this.state.dismissed = true;
		this.toggleDismiss = this.toggleDismiss.bind(this);
		this.closeForever = this.closeForever.bind(this);
		this.remindLater = this.remindLater.bind(this);
	}

	setup(resp) {
		if (this.state.dismissed) return;
		this.setState({ totalContributors: resp.totalContributors });
	}

	toggleDismiss(e) {
		e.preventDefault();
		this.setState({
			dismissIntent: !this.state.dismissIntent,
		});
	}

	closeForever() {
		setCookie("tpm_dismiss_fundraiser_components", 1, 30);
		this.setState({
			dismissed: true,
		});
	}

	remindLater() {
		setCookie("tpm_dismiss_fundraiser_components", 1, 3);
		this.setState({
			dismissed: true,
		});
	}

	formattedNumber(num) {
		return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
	}

	renderContent() {
		if (this.state.dismissed) return;

		if (this.state.dismissIntent) {
			return (
				<div className="FundraiserBanner__Inner --column">
					<div
						class="FundraiserBanner__Dismiss --back"
						onClick={this.toggleDismiss}
					>
						{/* <i class="fa-light fa-angle-left"></i> */}
						BACK
					</div>
					<div class="FundraiserBanner__DontSee">
						Don't want to see this message?
					</div>
					<div class="FundraiserBanner__Buttons">
						<div
							onClick={this.remindLater}
							class="Button --red FundraiserBanner__Button --sm"
						>
							REMIND ME LATER
						</div>
						<div
							onClick={this.closeForever}
							class="Button --red FundraiserBanner__Button --sm"
						>
							NOT INTERESTED
						</div>
						<div
							onClick={this.closeForever}
							class="Button --red FundraiserBanner__Button --sm"
						>
							<span class="hide-tiny">I </span>ALREADY CONTRIBUTED
						</div>
					</div>
				</div>
			);
		}

		if (this.showTotalContributors && !this.state.totalContributors) return;

		if (this.showTotalContributors && this.state.totalContributors) {
			return (
				<a
					className="FundraiserBanner__Inner --v2"
					href="https://accounts.talkingpointsmemo.com/contribute"
				>
					<div className="FundraiserBanner__ThankYou">
						THANK YOU to all our&nbsp;readers. We reached&nbsp;our&nbsp;goal!
					</div>

					<div class="FundraiserBanner__Dismiss" onClick={this.toggleDismiss}>
						<Icon name="xmark" style="sharp-light" />
					</div>
				</a>
			);
		}

		return (
			<a
				className="FundraiserBanner__Inner"
				href="https://accounts.talkingpointsmemo.com/contribute"
			>
				<div className="FundraiserBanner__Left">
					The&nbsp;TPM <br />
					Journalism
					<br /> Fund
				</div>
				<div className="FundraiserBanner__Center">
					Help&nbsp;Us&nbsp;Prepare For&nbsp;What's&nbsp;Next
				</div>
				<div className="FundraiserBanner__Right">
					<div className="FundraiserBanner__Arrow">
						<span>LEARN MORE</span>
					</div>
				</div>
				<div class="FundraiserBanner__Dismiss" onClick={this.toggleDismiss}>
					<Icon name="xmark" style="sharp-light" />
				</div>
			</a>
		);
	}
}
